/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AuthenticateWithPinRequest as DigiworkMaitreDDtoAuthenticationAuthenticateWithPinRequest } from '../../models/Digiwork/MaitreD/DTO/Authentication/authenticate-with-pin-request';

export interface Authenticate$Params {
      body?: DigiworkMaitreDDtoAuthenticationAuthenticateWithPinRequest
}

export function authenticate(http: HttpClient, rootUrl: string, params?: Authenticate$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, authenticate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

authenticate.PATH = '/api/wtr/User/authenticate';
